import { action } from '@ember/object';
import { service } from '@ember/service';

import PriorityDataUpdateDialog from '@databox/ember-integrations/lib/components/PriorityDataUpdateDialog/PriorityDataUpdateDialog';
import { create } from '@databox/ember-integrations/lib/components/Setup';

import type { PopupData, ReactIntegrations, Service } from 'webapp-types';

import didInsert from 'webapp/modifiers/did-insert';
import willDestroy from 'webapp/modifiers/will-destroy';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';

export default class SourcePopupPriorityDataUpdateComponent extends PopupInnerModalComponent<PopupData.Source.PriorityDataUpdate> {
	@service('react') declare reactService: Service.React;

	contentNode: ReactIntegrations.Root = null;

	@action
	setupView(node: HTMLElement) {
		this.contentNode = create(node as HTMLDivElement);

		const newProps = {
			...this.popupData,
			onRenderEnd: () => {
				this.reposition();
			},
		};

		this.reactService.render(this.contentNode, PriorityDataUpdateDialog(newProps));
	}

	@action
	teardownView(): void {
		if (this.contentNode) {
			this.contentNode.unmount();
			this.contentNode = null;
		}
	}
	<template>
		<div {{didInsert this.setupView}} {{willDestroy this.teardownView}}></div>
	</template>
}
